import {
  productItem,
  addTextItem,
  addUploadItem,
  addDesignItem,
  printStyleItem
} from './navigation-items';

export default [
  productItem,
  addUploadItem,
  addTextItem,
  addDesignItem,
  printStyleItem
];
